var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"main-footer pa-2",attrs:{"padless":"","app":""}},[_c('j-divider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }